import { customerBaseApi } from "@/react/services/api";

const BRANCHES = "BRANCHES";

export const branchesApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getBranches: build.query({
      query: () => ({
        url: `branches`,
        method: "GET",
      }),
      providesTags: [BRANCHES],
    }),
  }),
});

export const { useGetBranchesQuery } = branchesApi;
